import type { NextPage, GetServerSideProps } from 'next'
import RateSetList from '../../components/RateSet/RateSetList'
import Head from 'next/head'

const Index: NextPage = () => {
  return (
    <>
      <Head>
        <title>Rate Research Portal</title>
      </Head>
      <RateSetList />
    </>
  )
}

export default Index

export const getServerSideProps: GetServerSideProps = async () => {
  return { props: {} }
}
